<template>
    <v-app id="application" :class="[$route.query.ukuwinversion ? 'miniuku' : '', isSignupPage ? 'signup-bg' : '']">
        <StoreProvider class="fill-height">
            <IntercomController :is-mini-uku="$route.query.ukuwinversion !== undefined">
                <router-view></router-view>
            </IntercomController>
        </StoreProvider>
    </v-app>
</template>

<script>
import { StoreProvider } from "./store";
import IntercomController from "./IntercomController";
import { computed } from "@vue/composition-api";

export default {
    name: "App",
    components: {
        StoreProvider,
        IntercomController
    },
    setup(props, ctx) {
        const isSignupPage = computed(() => ctx.root._route.name === 'signup')

        return {
            isSignupPage
        }
    }
};
</script>

<style lang="scss" scoped>
.signup-bg {
    font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-image: url('/static/img/signup-dashboard.png') !important;
}
</style>
